export enum SystemProfessionalStatus {
    SystemProfi = 'SYSTEMPROFI'
}
